if (!customElements.get('modal-dialog')) {
  class ModalDialog extends HTMLElement {
    constructor() {
      super();

      this.age_verification = this.classList.contains('age-verification-modal');
      this.modalId = this.getAttribute('id');
      this.delay = parseInt(this.dataset.delay, 10) * 1000;
      this.popup = this.dataset.popup;
      this.sectionId = this.dataset.sectionId;
      this.disabled = this.hasAttribute('disabled');

      this.button = this.querySelector('[id^="ModalClose-"]');

      console.log(this.button)

      if (this.button) {
        this.button.addEventListener('click', this.hide.bind(this));
      } else {
        console.warn(`ModalDialog (${this.modalId}): close button not found.`);
      }

      if (!this.disabled) {
        this.addEventListener('keyup', (event) => {
          if (event.code.toUpperCase() === 'ESCAPE') {
            this.hide();
          }
        });
        this.addEventListener('click', (event) => {
          if (event.target === this) {
            this.hide();
          }
        });
      }

      if (this.delay && this.delay > 0 && !this.getCookie()) {
        setTimeout(() => {
          this.show();
          if (this.button) {
            this.button.addEventListener('click', this.setCookie.bind(this));
          }
        }, this.delay);
      }
      
      if (this.age_verification && !this.getCookie()) {
        this.show();
        if (this.button) {
          this.button.addEventListener('click', this.setCookie.bind(this));
        }
      }

      if (window.Shopify && Shopify.designMode) {
        this.moved = true;
        document.addEventListener('shopify:section:select', (event) => {
          if (event.detail.sectionId === this.sectionId) {
            this.show();
          }
        });
        document.addEventListener('shopify:section:deselect', (event) => {
          if (event.detail.sectionId === this.sectionId) {
            this.hide();
          }
        });
      }
    }

    connectedCallback() {
      if (!this.moved) {
        this.moved = true;
        let container = document.getElementById('modal-container');
        if (!container) {
          container = document.createElement('div');
          container.id = 'modal-container';
          document.body.appendChild(container);
        }
        container.appendChild(this);
      }
    }

    show(opener) {
      let container = document.getElementById('modal-container');
      if (container) {
        container.appendChild(this);
      }
      
      document.querySelectorAll('modal-dialog[open]').forEach((modal) => {
        if (modal !== this) {
          modal.hide();
        }
      });
      
      this.openedBy = opener;
      document.body.classList.add('overflow-hidden');
      this.setAttribute('open', '');
      setTimeout(() => {
        const dialog = this.querySelector('[role="dialog"]');
        if (dialog) {
          dialog.focus();
        }
      }, 100);
    }

    hide() {
      document.body.classList.remove('overflow-hidden');
      this.removeAttribute('open');
      this.pauseMedia();
    }

    pauseMedia() {
      this.querySelectorAll('.js-youtube').forEach((video) => {
        video.contentWindow.postMessage(
          '{"event":"command","func":"pauseVideo","args":""}',
          '*'
        );
      });
      this.querySelectorAll('.js-vimeo').forEach((video) => {
        video.contentWindow.postMessage('{"method":"pause"}', '*');
      });
      this.querySelectorAll('video').forEach((video) => video.pause());
    }

    getCookie() {
      return window.localStorage.getItem(this.modalId);
    }

    setCookie() {
      window.localStorage.setItem(this.modalId, JSON.stringify(new Date()));
    }
  }

  customElements.define('modal-dialog', ModalDialog);
}

if (!customElements.get('modal-opener')) {
  class ModalOpener extends HTMLElement {
    constructor() {
      super();
      const button = this.querySelector('button');
      if (!button) return;
      button.addEventListener('click', () => {
        const modalSelector = this.getAttribute('data-modal');
        const modal = document.querySelector(modalSelector);
        if (modal) {
          modal.show(button);
        }
      });
    }
  }
  customElements.define('modal-opener', ModalOpener);
}
